import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=703ed943&scoped=true"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"
import style0 from "./Domain.vue?vue&type=style&index=0&id=703ed943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ed943",
  null
  
)

export default component.exports